export const applyMiddleware = dispatch => action => {
  dispatch(action);
}